import { _ as s } from "./Tabs.vue_vue_type_script_setup_true_lang-CmnBP4i1.js";
import { T as c, a as f } from "./Tabs.vue_vue_type_script_setup_true_lang-CmnBP4i1.js";
import { _ as a } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const t = {
  "menu-tab": "_menu-tab_frbn6_2"
}, o = {
  $style: t
}, r = /* @__PURE__ */ a(s, [["__cssModules", o]]);
export {
  c as TABS_INJECTION,
  f as TabVariant,
  r as default
};
//# sourceMappingURL=Tabs.js.map
